module.exports = __webpack_public_path__ + "static/media/Puerto Rico.d758cc85.png";